import { ActionButtonVariants } from 'components/action-button';

export const theme = {
  itemNameTextTransform: 'none',
  buttonContainerMarginTop: '2rem',
  modalPadding: '3rem 3.10rem calc(3.5rem + env(safe-area-inset-bottom))',
  changeStoresButtonVariant: ActionButtonVariants.OUTLINE,
};
